import Swiper from 'swiper';

function initHomepageSlider(slider) {
    const sliderContainer = slider.querySelector('.swiper-container');
    const sliderTitles = slider.querySelectorAll('.slide-title');

    const removeTitles = () => {
        for (let i = 0; i < sliderTitles.length; i++) {
            sliderTitles[i].classList.remove('active');
        }
    };
    const activateTitle = (title, timeOut) => {
        setTimeout(() => {
            title.classList.add('active');
        }, timeOut);
    };
    const reFilterSlides = () => {
        const unfilteredSlides = sliderContainer.querySelectorAll('.unfilter');
        for (let i = 0; i < unfilteredSlides.length; i++) {
            unfilteredSlides[i].classList.remove('unfilter');
        }
    };
    const unFilterSlide = (slide, timeOut) => {
        if (slide.classList.contains('filter-bw')) {
            setTimeout(() => {
                slide.classList.add('unfilter');
            }, timeOut);
        }
    };

    const homeSlider = new Swiper(sliderContainer, {
        speed: 600,
        nextButton: slider.querySelector('.swiper-button-next'),
        prevButton: slider.querySelector('.swiper-button-prev'),
        onInit: function (swiper) {
            activateTitle(sliderTitles[0], 1200);
            unFilterSlide(swiper.slides[0], 1200);
        },
        onSlideChangeStart: function () {
            removeTitles();
            reFilterSlides();
        },
        onSlideChangeEnd: function (swiper) {
            const currentIndex = swiper.activeIndex;
            activateTitle(sliderTitles.item(currentIndex), 400);
            const currentSlide = swiper.slides[currentIndex];
            unFilterSlide(currentSlide, 400);
        }
    });
}

function initPackageSlider(slider) {
    const sliderContainer = slider.querySelector('.swiper-container');
    const sliderTitles = slider.querySelectorAll('.slide-title');
    const navigationContainer = slider.querySelector('.slider-navigation-wrapper');

    const removeTitles = () => {
        for (let i = 0; i < sliderTitles.length; i++) {
            sliderTitles[i].classList.remove('active');
        }
    };
    const activateTitle = (title, timeOut) => {
        setTimeout(() => {
            title.classList.add('active');
        }, timeOut);
    };
    const packageSlider = new Swiper(sliderContainer, {
        speed: 600,
        nextButton: slider.querySelector('.swiper-button-next'),
        prevButton: slider.querySelector('.swiper-button-prev'),
        onInit: function (swiper) {
            if (sliderTitles[0]) {
                activateTitle(sliderTitles[0], 0);
            }
            if (swiper.slides.length < 2) {
                slider.removeChild(navigationContainer);
                swiper.lockSwipes();
            }
        },
        onSlideChangeStart: function () {
            removeTitles();
        },
        onSlideChangeEnd: function (swiper) {
            const currentIndex = swiper.activeIndex;
            activateTitle(sliderTitles.item(currentIndex), 0);
        }
    });
}


document.addEventListener('DOMContentLoaded', () => {
    const homepageSliders = document.querySelectorAll('.homepage-slider');
    if (homepageSliders.length) {
        for (let i = 0; i < homepageSliders.length; i++) {
            initHomepageSlider(homepageSliders[i]);
        }
    }

    const packageSliders = document.querySelectorAll('.package-slider');
    if (packageSliders.length) {
        for (let i = 0; i < packageSliders.length; i++) {
            initPackageSlider(packageSliders[i]);
        }
    }
});


// WEBPACK FOOTER //
// ./assets/js/src/modules/swiper.js